export default __webpack_public_path__ + "locales/fr/JavascriptSdk.json?hash=c08546053d477916182c5a9cf7a3d765";